import { render, staticRenderFns } from "./HomePlaceholderElement.vue?vue&type=template&id=2632a2aa&scoped=true"
import script from "./HomePlaceholderElement.vue?vue&type=script&lang=js"
export * from "./HomePlaceholderElement.vue?vue&type=script&lang=js"
import style0 from "./HomePlaceholderElement.vue?vue&type=style&index=0&id=2632a2aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2632a2aa",
  null
  
)

export default component.exports